<template>
  <!-- 文件列表 -->
  <transition-group
    class="upload-file-list el-upload-list el-upload-list--text"
    name="el-fade-in-linear"
    tag="ul"
  >
    <li
      v-for="(url, index) in list"
      :key="index+url"
      class="el-upload-list__item ele-upload-list__item-content"
    >
      <el-link
        :href="url"
        :underline="false"
        target="_blank"
      >
        <span class="el-icon-picture"> 材料清单</span>
      </el-link>
    </li>
  </transition-group>
</template>

<script>
export default {
  props:{
    listData:{
      type:[String, Array]
    }
  },
  computed:{
    list() {
      if (this.listData && this.listData.length) {
        return this.listData.split(',');
      }else {
        return this.listData;
      }
    }
  }
};
</script>

<style>
.el-upload-list__item:first-child{
  margin-top: 0!important;
}
.el-upload-list__item:hover {
  background-color: transparent;
}
</style>